import {titleize} from 'shared/utils';

export const AWARD_MAP = {
  CampusVisitScholarship: {
    type: 'college-interaction',
    salutation: 'Great seeing you!',
    icon: 'university',
    description: () => 'Visiting Campus',
  },
  College101EventScholarship: {
    type: 'college-interaction',
    salutation: 'Great seeing you!',
    icon: 'university',
    description: () => 'Attending a College 101 Event',
  },
  CollegeFairScholarship: {
    type: 'college-interaction',
    salutation: 'Great seeing you!',
    icon: 'university',
    description: () => 'Attending a College Fair',
  },
  CollegeReceptionScholarship: {
    type: 'college-interaction',
    salutation: 'Great seeing you!',
    icon: 'university',
    description: () => 'Attending a College Reception',
  },
  CustomCollegeEventScholarship: {
    type: 'college-interaction',
    salutation: 'Great seeing you!',
    icon: 'university',
    description: ({item: {typeDisplay}}) => typeDisplay,
  },
  SummerProgramScholarship: {
    type: 'college-interaction',
    salutation: 'Hot streak!',
    icon: 'university',
    description: () => 'Participating in a Summer Program',
  },
  CommunityServiceScholarship: {
    type: 'community-service',
    salutation: 'Thank you!',
    icon: 'hand-holding-heart',
    description: ({item: {hours}}) => `Volunteering for ${hours} hours`,
  },
  CertificationScholarship: {
    type: 'courses',
    salutation: 'Certified!',
    icon: 'book',
    description: () => 'Getting a Certificate',
  },
  ChallengingClassScholarship: {
    type: 'courses',
    salutation: 'Rise to the challenge!',
    icon: 'book',
    description: ({item: {courseType}}) =>
      `Taking ${courseTypeArticle(courseType)} ${courseType} Class`,
  },
  CourseGradeScholarship: {
    type: 'courses',
    salutation: 'Brilliant!',
    icon: 'book',
    description: ({scholarship: {gradeMinimum}, item: {name}}) =>
      `Getting ${gradeMinimum === 'A' ? 'an' : 'a'} ${gradeMinimum} in ${name}`,
  },
  CourseSubjectScholarship: {
    type: 'courses',
    salutation: 'Brilliant!',
    icon: 'book',
    description: ({item: {subject}}) => `Taking a ${subject} Class`,
  },
  ForeignLanguageScholarship: {
    type: 'courses',
    salutation: '¡Muy bien!',
    icon: 'book',
    description: () => 'Foreign Language',
  },
  FullCourseLoadScholarship: {
    type: 'courses',
    salutation: 'Keep it up!',
    icon: 'book',
    description: () => 'Taking a Full Course Load',
  },
  OverallGpaScholarship: {
    type: 'courses',
    icon: 'book',
  },
  PerfectAttendanceScholarship: {
    type: 'courses',
    salutation: "You're on a roll!",
    icon: 'book',
    description: () => 'Perfect Attendance',
  },
  ExtracurricularActivityScholarship: {
    type: 'extracurricular',
    salutation: 'High five!',
    icon: 'chess',
    description: () => 'Participating in an Extracurricular Activity',
  },
  LeadershipScholarship: {
    type: 'extracurricular',
    salutation: "You're a boss!",
    icon: 'chess',
    description: () => 'Leadership Role',
  },
  SportsActivityScholarship: {
    type: 'extracurricular',
    salutation: 'Team work!',
    icon: 'chess',
    description: () => 'Playing a Sport',
  },
  FafsaScholarship: {
    type: 'courses',
    salutation: 'Well done!',
    icon: 'book',
    description: () => 'Completing the FAFSA',
  },
  HonorAwardScholarship: {
    type: 'honors-and-awards',
    salutation: 'Congrats!',
    icon: 'trophy',
    description: () => 'Receiving an Honor or Award',
  },
  MultimediaScholarship: {
    type: 'multimedia',
    salutation: 'Bravo!',
    icon: 'palette',
    description: () => 'Adding an Art Project',
  },
  CollegeReplacementScholarship: {
    type: 'honors-and-awards',
    icon: 'trophy',
  },
  ReferralScholarship: {
    type: 'referral',
    salutation: 'Woohoo!',
    icon: 'envelope',
    description: () => 'Referring a Friend',
  },
  ApScoreScholarship: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {score}}) => `Getting a ${score} on the AP Test`,
  },
  OtherTestScholarship: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {abbreviation, name}}) => `Scoring well on ${abbreviation || name}`,
  },
  PsatPreActScholarship: {
    type: 'test-scores',
    salutation: 'Way to go!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Taking the ${testScoreName(_type)}`,
  },
  PsatPreActScoreScholarship: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Scoring well on the ${testScoreName(_type)}`,
  },
  PsatPreActScoreScholarship2: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Scoring well on the ${testScoreName(_type)}`,
  },
  RegentScholarship: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: () => 'Regents Exam',
  },
  SatActScholarship: {
    type: 'test-scores',
    salutation: 'Way to go!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Taking the ${testScoreName(_type)}`,
  },
  SatActScoreScholarship: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Scoring well on the ${testScoreName(_type)}`,
  },
  SatActScoreScholarship2: {
    type: 'test-scores',
    salutation: 'Great score!',
    icon: 'file-alt',
    description: ({item: {_type}}) => `Scoring well on the ${testScoreName(_type)}`,
  },
  SurveyScholarship: {
    type: 'test-scores',
    salutation: 'Well done!',
    icon: 'clipboard-list',
    description: ({item: {name}}) => `Completing the ${titleize(name)} survey`,
  },
  TimeSensitiveItemScholarship: {
    type: 'work-experience',
    salutation: 'Well done!',
    icon: 'book',
    description: ({item: {type}}) => TIME_SENSITIVE_ITEM_DESCRIPTIONS[type],
  },
  WorkExperienceScholarship: {
    type: 'work-experience',
    salutation: 'Nice work!',
    icon: 'briefcase',
    description: ({item: {totalHours}}) => `${totalHours} hours of work experience`,
  },
};

const courseTypeArticle = (courseType) => {
  switch (courseType.toLowerCase()) {
    case 'regular':
    case 'pre-ap':
    case 'pre-ib':
    case 'college level':
    case 'dual enrollment':
    case 'certification':
      return 'a';
    case 'honors':
    case 'advanced':
    case 'ap':
    case 'ib':
      return 'an';
  }
};

const testScoreName = (testScore) => {
  switch (testScore) {
    case 'PsatScore':
    case 'PsatScore2015':
      return 'PSAT';
    case 'ActPlanScore':
    case 'PreActScore':
      return 'Pre-ACT';
    case 'SatScore':
    case 'SatScore2016':
      return 'SAT';
    case 'ActScore':
      return 'Legacy ACT';
    case 'ActScore2025':
      return 'ACT';
  }
};

const TIME_SENSITIVE_ITEM_DESCRIPTIONS = {
  orientation: 'Signing up for orientation!',
};
